module.exports = __webpack_public_path__ + "img/election-day-campaign.62eb0fc5.jpg";